import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'subgroups',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'subgroups-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {                           
                        transKey: 'breadcrumbs.subgroups-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "subgroups-index" */ '@/modules/configurations/catalogs/subgroups/views/Index.vue')
        },
        {
            path: 'create',
            name: 'subgroups-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'subgroups-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.subgroups-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.subgroups-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "subgroups-create" */ '@/modules/configurations/catalogs/subgroups/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'subgroups-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'subgroups-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.subgroups-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.subgroups-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "subgroups-edit" */ '@/modules/configurations/catalogs/subgroups/views/Edit.vue')
        }
    ]
}